import Fuse from 'fuse.js';
/**
 * This function can be used instead of the standardSearchFilter function inside the ContextMenu component to provide a fuzzy search
 * @param threshold fuse.js threshold => https://www.fusejs.io/api/options.html#threshold
 */
export const getFuzzySearchFilter = (threshold = 0.3) => {
  return (item, searchString) => {
    const fuse = new Fuse([item.label], {
      includeScore: true,
      includeMatches: true,
      threshold
    });
    const result = fuse.search(searchString);
    const match = result[0]?.matches?.[0];
    if (match && match.indices.length > 0) {
      const [bestIndex] = [...match.indices].sort((a, b) => {
        return b[1] - b[0] - (a[1] - a[0]);
      });
      return {
        highlightStart: bestIndex[0],
        highlightEnd: bestIndex[1]
      };
    }
    return undefined;
  };
};